import { Outlet } from 'react-router-dom';

export const Q2025Layout = () => {
  return <Outlet />;
};
